import GoalsSerializer from './base';

export default class Goal extends GoalsSerializer {}
